module.exports = __webpack_public_path__ + "img/turck1.a14fa0b8.svg";